export const ADD_GIFT_CART_REQUEST = "ADD_GIFT_CART_REQUEST";
export const ADD_GIFT_CART_SUCCESS = "ADD_GIFT_CART_SUCCESS";
export const ADD_GIFT_CART_FAILURE = "ADD_GIFT_CART_FAILURE";
export const CLEAN_ADDED_GIFT_CART = "CLEAN_ADDED_GIFT_CART";


export const GET_GIFT_CART_REQUEST = "GET_GIFT_CART_REQUEST";
export const GET_GIFT_CART_SUCCESS = "GET_GIFT_CART_SUCCESS";
export const GET_GIFT_CART_FAILURE = "GET_GIFT_CART_FAILURE";